import SearchConsumer from './SearchConsumer/SearchConsumer'
import AddConsumer from './AddConsumer/AddConsumer'
import ConsumerBlock from './ConsumerBlock/ConsumerBlock'
import PaymentModal from './PaymentModal/PaymentModal'
import SearchPrevConsumer from './SearchPrevConsumer/SearchPrevConsumer'

export { SearchConsumer, AddConsumer, ConsumerBlock, PaymentModal, SearchPrevConsumer }
